import { useState } from 'react';
import { useSiteConfig } from '../selectors/global';
import _ from 'lodash';

type TRandomMode = 'server-random' | 'server-random2' | 'user-random' | 'sample';

export function useRandomComponent(variants: any[], mode: TRandomMode = 'server-random') {
  const siteConfig = useSiteConfig();
  const [variantComponent] = useState(() => {
    if (mode === 'server-random') {
      return variants[siteConfig.seed % variants.length];
    } else if (mode === 'server-random2') {
      return variants[siteConfig.seed2 % variants.length];
    } else if (mode === 'user-random') {
      return variants[siteConfig.userSeed % variants.length];
    } else {
      return _.sample(variants);
    }
  });
  return variantComponent;
}
